///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, campaignPromoActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getCampaignPromo = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_CAMPAIGN_PROMO(payload.idCampaign)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(campaignPromoActionCreators.getCampaignPromoSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(campaignPromoActionCreators.getCampaignPromoFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateCampaignPromo = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.UPDATE_CAMPAIGN_PROMO(payload.idCampaign)
	const dataFormat = payload.data

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFormat)

		yield put(campaignPromoActionCreators.updateCampaignPromoSuccess(data.data, payload.idCampaign))

		yield put(toastSuccessActionCreators.hydrateToast('toast__promotionManagement__update'))
	} catch (e) {
		if (e.response?.status !== 400) {
			yield put(errorManagerActionCreators.createError(e.response))
		} else {
			yield put(campaignPromoActionCreators.updateCampaignPromoFailure(e.response))
		} // guard to layout modal error on managed error
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const cancelCampaignPromo = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CANCEL_CAMPAIGN_PROMO(payload.idCampaign)
	const dataFormat = payload.data

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, dataFormat)

		yield put(campaignPromoActionCreators.cancelCampaignPromoSuccess(data.data, payload.idCampaign))

		yield put(toastSuccessActionCreators.hydrateToast('toast__promotionManagement__cancel'))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(campaignPromoActionCreators.cancelCampaignPromoFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const createCampaignPromo = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CREATE_CAMPAIGN_PROMO(payload.action)
	const dataFormat = payload.campaign

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFormat)

		yield put(campaignPromoActionCreators.createCampaignPromoSuccess(data.data, payload.idCampaign))
		yield put(campaignPromoActionCreators.resetCampaignPromo())

		yield put(toastSuccessActionCreators.hydrateToast('toast__promotionManagement__creation'))
	} catch (e) {
		if (e.response?.status !== 400) {
			yield put(errorManagerActionCreators.createError(e.response))
		} else {
			yield put(campaignPromoActionCreators.createCampaignPromoFailure(e.response))
		} // guard to layout modal error on managed error
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const checkCampaignPromo = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.CHECK_ITEMS_CAMPAIGN_PROMO(payload.target)

	const dataFormat = payload.campaign

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, dataFormat)

		yield put(campaignPromoActionCreators.checkCampaignPromoSuccess(data.data, payload.idCampaign))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(campaignPromoActionCreators.checkCampaignPromoFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_CAMPAIGN_PROMO, getCampaignPromo)
	yield takeLatest(ActionsTypes.UPDATE_CAMPAIGN_PROMO, updateCampaignPromo)
	yield takeLatest(ActionsTypes.CANCEL_CAMPAIGN_PROMO, cancelCampaignPromo)
	yield takeLatest(ActionsTypes.POST_CHECK_CAMPAIGN_PROMO, checkCampaignPromo)
	yield takeLatest(ActionsTypes.CREATE_CAMPAIGN_PROMO, createCampaignPromo)
}

export default sagas
